import React from "react";
import GenericForm from "../GenericForm";
import StringInput from "../../formElements/StringInput";

function ServiceCaseTypeForm(props) {

    const formContent = (data, update) => (
        <>
            <StringInput name={'Nazov'} label={'Názov'} value={data.Nazov} onChange={update}/>
        </>
    )

    return (
        <GenericForm label="Typ Servisu"
                     labelNew="Pridať Typ Servisu"
                     baseUrl='/service_case/service_cases_types/'
                     formContent={formContent}/>
    )
}

export default ServiceCaseTypeForm
